import React, {useEffect, useState} from 'react'
import 'react-datepicker/dist/react-datepicker.css'
import * as dayjs from 'dayjs'
import * as utc from 'dayjs/plugin/utc'
import * as timezone from 'dayjs/plugin/timezone'
import * as relativeTime from 'dayjs/plugin/relativeTime'
import {ActionButton, Alert, useAlert} from "./components/FormComps"
import {useIntlEx} from "./components/IntlUtils.js"
import getLogger from "./components/Logging.js"
import './App.css'
import {useSolv} from "./components/SolvProvider";
import {closeDialog, ModalDialog} from "./components/DialogUtils";
import {mkHref} from "./components/AccountUtils";

const log = getLogger("BroadcastDeleteDialog")

dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.extend(relativeTime)

export default function BroadcastDeleteDialog(props)  {

  const { api, setBusy } = useSolv()
  const { intl } = useIntlEx()

  const [alert, setAlert] = useAlert()

  const [tenant, setTenant] = useState(null)

  useEffect(() => {
    if (props.tenant) {
      setTenant(props.tenant)
    }
  }, [props])

  function handleDeleteClick() {
    // log.debug("handleDeleteClick: invoked")
    setBusy("Deleting...")
    try {
      api.deleteBroadcast(tenant.tenantId, props.broadcastId)
        .then((data) => {
          window.location = mkHref({suffix: `/broadcasts`, tenant: tenant})
        })
        .catch((error) => {
          setAlert({type: "error", text: intl.msg("broadcast_delete_failed")})
        })
        .finally(() => {
          setBusy(null)
        })
    }
    catch (error) {
      setAlert({type: "error", text: intl.msg("error_failed")})
    }
  }

  function handleOpenDialog() {
    setAlert(null)
  }

  function handleCloseDialog() {
    closeDialog("dlg_broadcast_delete")
  }


  return (

    tenant &&
      <ModalDialog
        dialogId="dlg_broadcast_delete"
        size="md" keyboard={"true"} backdrop={props.backdrop || "static"}
        alert={alert}
        onOpen={handleOpenDialog}
        onClose={handleCloseDialog}>

        <ModalDialog.Header
          title={intl.msg("broadcast_delete_title")}
          alert={alert}/>

        <ModalDialog.Body>

          <Alert alert={{type: "warning", text: intl.msg("broadcast_delete_text_1", {broadcastName: props.broadcastName})}} align="center"/>

        </ModalDialog.Body>

        <ModalDialog.Footer>
          <ModalDialog.Footer.Controls>
            <ActionButton name="cancel" onClick={handleCloseDialog}/>
            <ActionButton name="delete" confirm={intl.msg("confirm_delete")} flavor="primary" onClick={handleDeleteClick}/>
          </ModalDialog.Footer.Controls>
        </ModalDialog.Footer>

    </ModalDialog>
  )
}